import axios from 'axios';
import {baseURL} from '../Constants';

const categoryURL = `${baseURL}therapeuticAreas/`;

export function getAreaList() {
  return axios
    .get(categoryURL)
    .then((response) => response)
    .catch((response) => response);
}

export function getArea(areaId) {
  return axios
    .get(`${categoryURL}${areaId}`)
    .then((response) => response)
    .catch((response) => response);
}

export function addArea(data) {
  return axios
    .post(categoryURL, data)
    .then((response) => response)
    .catch((response) => response);
}

export function updateArea(data) {
  return axios
    .put(`${categoryURL}${data.id}/`, data)
    .then((response) => response)
    .catch((response) => response);
}

export function deleteArea(area) {
  return axios
    .delete(`${categoryURL}${area.id}/`, area)
    .then((response) => response)
    .catch((response) => response);
}



// WEBPACK FOOTER //
// ./src/therapeuticArea/therapeuticAreaApi.js